import {createGlobalStyle} from "styled-components";

const TextSecondaryColor = "#54595F"
export const theme = {
  typography: {
    fontFamily: [
      'Montserrat Alternates',
    ].join(','),
  },
  colors: {
    primary: '#000000',
    secondary: '#54595F',
    warning: '#ffcc00',
    admins: 'rgba(255,204,0,0.15)',
    text: '#7A7A7A',
    success: '#4caf50',
    successBackground: 'rgba(137, 187, 139, 0.09)',
    disabledTransparent: ' #0000008c',
    accent: '#690038'
  },
  spacing: (value: number) => {
    return `${8 * value}px`
  }

}

export const GlobalStyles = createGlobalStyle`

  body {
    margin: 0;
    padding: 0;
  }

  * {
    font-family: 'Montserrat Alternates', sans-serif;
  }
`

